module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnBAMAAACPhheLAAAAAXNSR0IB2cksfwAAABtQTFRFAAAAkMr4j8n3kMr7kMr6kMr5j8v3GXbSlXXN8BUx0QAAAAl0Uk5TAMFCPr3/QP//0GKL7gAAAEhJREFUeJxjYGAQYmAwQcYMIBAqlhKKjCGCaIDuguHlUFBKPUHaubM0HIvtaIKDy8yODnTBjg6IIAogRhCrdgrNJEsQE1AoCABA3wB4e256PQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icons8-check@2x.png
// module id = zVzb
// module chunks = 1